import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./auth/slice";
import { logSlice } from "./questionStore/logSlice";
import { AuthAPI } from "../apis/AuthAPI";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    log: logSlice.reducer,
    // login: loginSlice.reducer,
    // editProfile: editProfileSlice.reducer,
    // questions: questionSlice.reducer,
    // demands: demandSlice.reducer,
    // teacherDemands: teacherDemandSlice.reducer,
    // teacherDemandsManager: teacherDemandManagerSlice.reducer,
    // teacherDemandManagerQuestion: teacherDemandManagerQuestionSlice.reducer,
    // demandsManager: demandManagerSlice.reducer,
    // disciplines: disciplineSlice.reducer,
    // organizations: organizationSlice.reducer,
    // userAdmin: userAdminSlice.reducer,
    // userColaborator: userColaboratorSlice.reducer,
    // userTeacher: userTeacherSlice.reducer,
    // userStudent: userStudentSlice.reducer,
    // exams: examsSlice.reducer,
    // layouts: layoutsSlice.reducer,
    // studentExams: studentExamsSlice.reducer,
    // units: unitSlice.reducer,
    // courses: courseSlice.reducer,
    // classes: classSlice.reducer,
    // corrections: correctionSlice.reducer,
    // registrations: registrationSlice.reducer,
    // correctionExams: correctionExamSlice.reducer,
    // correctionStudents: correctionStudentSlice.reducer,
    // correctionQuestions: correctionQuestionSlice.reducer,
    // dashboard: dashboardSlice.reducer,    // logs: logSlice.reducer,
    // uploadExam: uploadExamSlice.reducer,
    // tests: testSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const { setTokenAndMe, logout, setLoading } = authSlice.actions;

const getAsyncStorage = () => {
  return async (dispatch, getState) => {
    const currentState = getState();
    const token = localStorage.getItem("token");


    // If no token, set logged out state immediately
    if (!token) {
      dispatch(logout());
      return;
    }

    // If already logged and has valid user data, skip API call
    if (currentState.auth.logged && currentState.auth.me?.id) {
      dispatch(setLoading(false));
      return;
    }

    // Token exists but not authenticated yet, validate it
    dispatch(setLoading(true));

    try {
      const result = await AuthAPI.me(token);
      
      // Validate response structure
      if (result?.data) {
        dispatch(setTokenAndMe({ 
          token: token, 
          me: result.data 
        }));
      } else {
        console.error('Invalid API response structure:', result);
        dispatch(logout());
      }
    } catch (error) {
      
      // Check for authentication errors
      const isAuthError = 
        error?.errors?.[0]?.status === 401 ||
        error?.errors?.[0]?.status === 403 ||
        error?.status === 401 ||
        error?.status === 403 ||
        error === 403;

      if (isAuthError) {
        dispatch(logout());
      } else {
        dispatch(setLoading(false));
      }
    }
  };
};

// Export the validation function for use in components
export const validateToken = () => {
  return store.dispatch(getAsyncStorage());
};

// Don't auto-initialize - let the component handle it to avoid race conditions
// store.dispatch(getAsyncStorage());
